"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createListCollection } from "@ark-ui/react/select";
import { CaretDown, Check } from "@phosphor-icons/react";
import { forwardRef, useMemo } from "react";
import * as RawSelect from "./RawSelect";
export const Select = forwardRef((_a, ref) => {
    var { items, groups, label, placeholder, itemIndicator } = _a, props = __rest(_a, ["items", "groups", "label", "placeholder", "itemIndicator"]);
    const collection = useMemo(() => {
        let collectionItems = [];
        if (items) {
            collectionItems = items;
        }
        if (groups) {
            collectionItems = groups.flatMap((group) => group.items);
        }
        return createListCollection({ items: collectionItems });
    }, [items, groups]);
    return (_jsxs(RawSelect.Root, Object.assign({ ref: ref, collection: collection }, props, { children: [label != null ? _jsx(RawSelect.Label, { children: label }) : null, _jsx(RawSelect.Control, { children: _jsxs(RawSelect.Trigger, { children: [_jsx(RawSelect.ValueText, { placeholder: placeholder }), _jsx(CaretDown, {})] }) }), _jsx(RawSelect.Positioner, { children: _jsx(RawSelect.Content, { children: (groups !== null && groups !== void 0 ? groups : [{ items: collection.items }]).map((group, index) => {
                        var _a;
                        return (_jsxs(RawSelect.ItemGroup, { children: [group.label != null ? (_jsx(RawSelect.ItemGroupLabel, { children: group.label })) : null, group.items.map((item) => (_jsxs(RawSelect.Item, { item: item, children: [item.children ? (item.children) : (_jsx(RawSelect.ItemText, { children: item.label })), _jsx(RawSelect.ItemIndicator, { children: itemIndicator !== null && itemIndicator !== void 0 ? itemIndicator : _jsx(Check, {}) })] }, item.value)))] }, (_a = group.label) !== null && _a !== void 0 ? _a : index));
                    }) }) })] })));
});
//# sourceMappingURL=Select.js.map